import { render, staticRenderFns } from "./AppTemplate.vue?vue&type=template&id=13076dc6"
import script from "./AppTemplate.vue?vue&type=script&lang=js"
export * from "./AppTemplate.vue?vue&type=script&lang=js"
import style0 from "./AppTemplate.vue?vue&type=style&index=0&id=13076dc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports